import { IconButton, Tooltip } from '@mui/material';
import HomeTwoToneIcon from '@mui/icons-material/HomeTwoTone'; // you can use Home or Franchise icon
import { useNavigate } from 'react-router-dom';

function FranchiseHomeIcon({ redirectTo = '/logon-franchisee' }) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(redirectTo); // redirect to home or franchise page
  };

  return (
    <Tooltip arrow title={redirectTo === '/logon-franchisee' ? 'Home' : 'Franchise'}>
      <IconButton color="primary" onClick={handleClick}>
        <HomeTwoToneIcon />
      </IconButton>
    </Tooltip>
  );
}

export default FranchiseHomeIcon;
